import styled from 'styled-components/macro';

export const ToastWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;

  & > *:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const ToastTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Text = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: #495466;
`;

export const ToastSubtitle = styled.span<{ onClick?: () => void }>`
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: ${(props) => (props.onClick ? '#2D67D8' : '#1f2939')};
`;
